// extracted by mini-css-extract-plugin
export default {"BarTitleIcon":"BarTitle_BarTitleIcon__6kmpT"};